import counties from "./counties";

export default { counties };
